// extracted by mini-css-extract-plugin
export default {"content":"FeaturedArticle_content__z7KFS","article":"FeaturedArticle_article__HkER3","paragraph":"FeaturedArticle_paragraph__hlp3g","link":"FeaturedArticle_link__J0wVL"};